module.exports = __webpack_public_path__ + "static/media/giftBlueIcon.f1ff0218.png";